

























import Vue from 'vue';
import scheduleRuleVuex from '../../../vuex/common';
import customerClient from '../../../../customer/apis';
import CustomerProp, { PropType } from '../../../../customer/models/CustomerProp';

export default Vue.extend({
  mixins: [scheduleRuleVuex],
  data() {
    return {
      timeField: null,
    };
  },
  props: {
    timeFieldBased: {
      type: Object,
      default: null,
    },
  },
  computed: {
    dateFields(): CustomerProp[] {
      return this.customerState.props.filter(r => r.propType === PropType.LocalDate);
    },
  },
  methods: {
    loadCustomerProps() {
      customerClient.getProps().success((r) => {
        this.$store.commit('SET_CUSTOMER_PROPS', r.props);
      });
    },
    confirmField() {
      const prop = this.dateFields.find(r => r.fieldName === this.timeField);
      this.$store.commit('UPDATE_TIME_FIELD_BASED', {
        key: 'prop',
        value: prop,
      });
      this.$store.commit('UPDATE_TIME_FIELD_BASED', {
        key: 'field',
        value: prop!.fieldName,
      });
      this.$emit('close');
    },
    initTimeFieldBased() {
      if (this.timeFieldBased.field) {
        const tfb = JSON.parse(JSON.stringify(this.timeFieldBased));
        this.timeField = tfb.field;
      }
    },
  },
  mounted() {
    this.initTimeFieldBased();
    this.loadCustomerProps();
  },
});
